export const phpBool = (phpstring) => {
    if (phpstring === "1")
        return true;
    if (phpstring === true)
        return true;
    return false;
};
